module.exports = __webpack_public_path__ + "img/图片19.87628a31.png";